// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.triggerWrapper--Paal0 {
  position: relative;
  display: inline-flex;
  align-items: center;
  gap: 4px;
}

.trigger--aEidz {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  height: 30px;
  font-family: museo-sans;
  font-size: 14px;
  font-weight: 300;
  color: #000;
  line-height: 1;
  white-space: nowrap;
}

[dir] .trigger--aEidz {
  padding: 0 9px;
  border: 1px solid #c3c3c3;
  border-radius: 30px;
  background: white;
  cursor: pointer;
}

[dir] .trigger--aEidz:hover {
  border-color: #999;
}

.triggerIcon--lWZSs {
  width: 16px;
  height: 16px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
}

.triggerIcon--lWZSs svg {
  width: 16px;
  height: 16px;
}

.triggerLabel--tQnyI {
  display: inline;
}

.chevron--yXleK {
  color: #e6512d;
  width: 12px;
  height: 12px;
  display: inline-flex;
  align-items: center;
  transition: transform 0.2s ease;
}

[dir=ltr] .chevronOpen--SdQRf {
  transform: rotate(180deg);
}

[dir=rtl] .chevronOpen--SdQRf {
  transform: rotate(-180deg);
}

.chevron--yXleK svg {
  width: 12px;
  height: 12px;
}

.dropdown--Tb4Mp {
  position: absolute;
  top: calc(100% + 4px);
  z-index: 10;
  min-width: 220px;
}

[dir] .dropdown--Tb4Mp {
  background: white;
  border: 1px solid #c3c3c3;
  border-radius: 2px;
  box-shadow: 0px 1px 4px rgba(0, 0, 0, 0.25);
  padding: 10px 0;
}

[dir=ltr] .dropdown--Tb4Mp {
  left: 0;
}

[dir=rtl] .dropdown--Tb4Mp {
  right: 0;
}

[dir=ltr] .dropdownAlignRight--pS78x {
  left: auto;
  right: 0;
}

[dir=rtl] .dropdownAlignRight--pS78x {
  right: auto;
  left: 0;
}

.option--YZ4oV {
  display: flex;
  align-items: center;
  gap: 10px;
  font-family: museo-sans;
  font-size: 14px;
  font-weight: 300;
  color: #000;
  -webkit-user-select: none;
     -moz-user-select: none;
          user-select: none;
}

[dir] .option--YZ4oV {
  padding: 7px 12px;
  cursor: pointer;
}

[dir] .option--YZ4oV:hover {
  background: #f5f5f5;
}

.checkbox--Wf1EN {
  width: 24px;
  height: 24px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  transition:
    background 0.15s ease,
    border-color 0.15s ease;
}

[dir] .checkbox--Wf1EN {
  border: 2px solid #c3c3c3;
  border-radius: 4px;
  background: white;
}

[dir] .checkboxChecked--n1LWS {
  background: #e6512d;
  border-color: #e6512d;
}

.checkmark--WvQso {
  width: 14px;
  height: 14px;
  color: white;
}

.optionLabel--vNagh {
  font-weight: 300;
}

.optionLabelChecked--jF0WI {
  font-weight: 700;
}

.optionCount--GB6gl {
  color: #666;
  font-size: 12px;
  font-weight: 400;
}

[dir=ltr] .optionCount--GB6gl {
  margin-left: auto;
  padding-left: 8px;
}

[dir=rtl] .optionCount--GB6gl {
  margin-right: auto;
  padding-right: 8px;
}

.actions--VQyJM {
  display: flex;
  gap: 5px;
}

[dir] .actions--VQyJM {
  padding: 12px 10px 6px;
  border-top: none;
  margin-top: 8px;
}

.cancelBtn--bfdCt {
  font-family: museo-sans;
  font-size: 13px;
  font-weight: 700;
  color: #000;
  width: 110px;
}

[dir] .cancelBtn--bfdCt {
  padding: 8px 20px;
  border: 1px solid #e6512d;
  border-radius: 40px;
  background: white;
  cursor: pointer;
  text-align: center;
}

[dir] .cancelBtn--bfdCt:hover {
  background: #f5f5f5;
}

.confirmBtn--CZYtd {
  color: white;
  font-family: museo-sans;
  font-size: 13px;
  font-weight: 700;
  width: 110px;
}

[dir] .confirmBtn--CZYtd {
  padding: 9px 20px;
  border: 1px solid #e6512d;
  border-radius: 40px;
  background: #e6512d;
  cursor: pointer;
  text-align: center;
}

[dir] .confirmBtn--CZYtd:hover {
  background: #c9431f;
  border-color: #c9431f;
}

.confirmBtnDisabled--jHX9T {
  opacity: 0.5;
}

.infoIcon--uP4ah {
  display: inline-flex;
  align-items: center;
  color: #666;
}

[dir] .infoIcon--uP4ah {
  cursor: pointer;
}

[dir=ltr] .infoIcon--uP4ah {
  margin-left: 4px;
}

[dir=rtl] .infoIcon--uP4ah {
  margin-right: 4px;
}

@media screen and (max-width: 767px) {
  .hideLabelOnMobile--bv70x .trigger--aEidz {
    height: 30px;
    min-width: 43px;
  }
  [dir] .hideLabelOnMobile--bv70x .trigger--aEidz {
    padding: 0 8px;
  }

  .hideLabelOnMobile--bv70x .triggerLabel--tQnyI {
    display: none;
  }

  .dropdown--Tb4Mp {
    min-width: 180px;
    max-width: calc(100vw - 32px);
  }
}
`, "",{"version":3,"sources":["webpack://./src/js/components/SubjectPickerMenu/SubComponents/QuickSelectDropdown/styles.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,YAAY;EAMZ,uBAAuB;EACvB,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,cAAc;EACd,mBAAmB;AACrB;;AAhBA;EAKE,cAAc;EACd,yBAAyB;EACzB,mBAAmB;EACnB,iBAAiB;EACjB,eAAe;AAOjB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,WAAW;EACX,YAAY;EACZ,oBAAoB;EACpB,mBAAmB;EACnB,+BAA+B;AACjC;;AAEA;EACE,yBAAyB;AAC3B;;AAFA;EACE,0BAAyB;AAC3B;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,qBAAqB;EAErB,WAAW;EAKX,gBAAgB;AAElB;;AAXA;EAKE,iBAAiB;EACjB,yBAAyB;EACzB,kBAAkB;EAClB,2CAA2C;EAE3C,eAAe;AACjB;;AAXA;EAGE,OAAO;AAQT;;AAXA;EAGE,QAAO;AAQT;;AAEA;EACE,UAAU;EACV,QAAQ;AACV;;AAHA;EACE,WAAU;EACV,OAAQ;AACV;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EAGT,uBAAuB;EACvB,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,yBAAiB;KAAjB,sBAAiB;UAAjB,iBAAiB;AACnB;;AAXA;EAIE,iBAAiB;EACjB,eAAe;AAMjB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EAGZ,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;EAEd;;2BAEyB;AAC3B;;AAbA;EAGE,yBAAyB;EACzB,kBAAkB;EAKlB,iBAAiB;AAInB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,YAAY;AACd;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EAGE,WAAW;EACX,eAAe;EACf,gBAAgB;AAClB;;AANA;EACE,iBAAiB;EACjB,iBAAiB;AAInB;;AANA;EACE,kBAAiB;EACjB,kBAAiB;AAInB;;AAEA;EACE,aAAa;EACb,QAAQ;AAIV;;AANA;EAGE,sBAAsB;EACtB,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EAME,uBAAuB;EACvB,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,YAAY;AAEd;;AAZA;EACE,iBAAiB;EACjB,yBAAyB;EACzB,mBAAmB;EACnB,iBAAiB;EACjB,eAAe;EAMf,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EAKE,YAAY;EAEZ,uBAAuB;EACvB,eAAe;EACf,gBAAgB;EAChB,YAAY;AAEd;;AAZA;EACE,iBAAiB;EACjB,yBAAyB;EACzB,mBAAmB;EACnB,mBAAmB;EAEnB,eAAe;EAKf,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EAGnB,WAAW;AACb;;AANA;EAIE,eAAe;AAEjB;;AANA;EAGE,gBAAgB;AAGlB;;AANA;EAGE,iBAAgB;AAGlB;;AAEA;EACE;IACE,YAAY;IACZ,eAAe;EAEjB;EAJA;IAGE,cAAc;EAChB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,gBAAgB;IAChB,6BAA6B;EAC/B;AACF","sourcesContent":[".triggerWrapper {\n  position: relative;\n  display: inline-flex;\n  align-items: center;\n  gap: 4px;\n}\n\n.trigger {\n  display: inline-flex;\n  align-items: center;\n  gap: 4px;\n  height: 30px;\n  padding: 0 9px;\n  border: 1px solid #c3c3c3;\n  border-radius: 30px;\n  background: white;\n  cursor: pointer;\n  font-family: museo-sans;\n  font-size: 14px;\n  font-weight: 300;\n  color: #000;\n  line-height: 1;\n  white-space: nowrap;\n}\n\n.trigger:hover {\n  border-color: #999;\n}\n\n.triggerIcon {\n  width: 16px;\n  height: 16px;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.triggerIcon svg {\n  width: 16px;\n  height: 16px;\n}\n\n.triggerLabel {\n  display: inline;\n}\n\n.chevron {\n  color: #e6512d;\n  width: 12px;\n  height: 12px;\n  display: inline-flex;\n  align-items: center;\n  transition: transform 0.2s ease;\n}\n\n.chevronOpen {\n  transform: rotate(180deg);\n}\n\n.chevron svg {\n  width: 12px;\n  height: 12px;\n}\n\n.dropdown {\n  position: absolute;\n  top: calc(100% + 4px);\n  left: 0;\n  z-index: 10;\n  background: white;\n  border: 1px solid #c3c3c3;\n  border-radius: 2px;\n  box-shadow: 0px 1px 4px rgba(0, 0, 0, 0.25);\n  min-width: 220px;\n  padding: 10px 0;\n}\n\n.dropdownAlignRight {\n  left: auto;\n  right: 0;\n}\n\n.option {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  padding: 7px 12px;\n  cursor: pointer;\n  font-family: museo-sans;\n  font-size: 14px;\n  font-weight: 300;\n  color: #000;\n  user-select: none;\n}\n\n.option:hover {\n  background: #f5f5f5;\n}\n\n.checkbox {\n  width: 24px;\n  height: 24px;\n  border: 2px solid #c3c3c3;\n  border-radius: 4px;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  flex-shrink: 0;\n  background: white;\n  transition:\n    background 0.15s ease,\n    border-color 0.15s ease;\n}\n\n.checkboxChecked {\n  background: #e6512d;\n  border-color: #e6512d;\n}\n\n.checkmark {\n  width: 14px;\n  height: 14px;\n  color: white;\n}\n\n.optionLabel {\n  font-weight: 300;\n}\n\n.optionLabelChecked {\n  font-weight: 700;\n}\n\n.optionCount {\n  margin-left: auto;\n  padding-left: 8px;\n  color: #666;\n  font-size: 12px;\n  font-weight: 400;\n}\n\n.actions {\n  display: flex;\n  gap: 5px;\n  padding: 12px 10px 6px;\n  border-top: none;\n  margin-top: 8px;\n}\n\n.cancelBtn {\n  padding: 8px 20px;\n  border: 1px solid #e6512d;\n  border-radius: 40px;\n  background: white;\n  cursor: pointer;\n  font-family: museo-sans;\n  font-size: 13px;\n  font-weight: 700;\n  color: #000;\n  width: 110px;\n  text-align: center;\n}\n\n.cancelBtn:hover {\n  background: #f5f5f5;\n}\n\n.confirmBtn {\n  padding: 9px 20px;\n  border: 1px solid #e6512d;\n  border-radius: 40px;\n  background: #e6512d;\n  color: white;\n  cursor: pointer;\n  font-family: museo-sans;\n  font-size: 13px;\n  font-weight: 700;\n  width: 110px;\n  text-align: center;\n}\n\n.confirmBtn:hover {\n  background: #c9431f;\n  border-color: #c9431f;\n}\n\n.confirmBtnDisabled {\n  opacity: 0.5;\n}\n\n.infoIcon {\n  display: inline-flex;\n  align-items: center;\n  margin-left: 4px;\n  cursor: pointer;\n  color: #666;\n}\n\n@media screen and (max-width: 767px) {\n  .hideLabelOnMobile .trigger {\n    height: 30px;\n    min-width: 43px;\n    padding: 0 8px;\n  }\n\n  .hideLabelOnMobile .triggerLabel {\n    display: none;\n  }\n\n  .dropdown {\n    min-width: 180px;\n    max-width: calc(100vw - 32px);\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"triggerWrapper": `triggerWrapper--Paal0`,
	"trigger": `trigger--aEidz`,
	"triggerIcon": `triggerIcon--lWZSs`,
	"triggerLabel": `triggerLabel--tQnyI`,
	"chevron": `chevron--yXleK`,
	"chevronOpen": `chevronOpen--SdQRf`,
	"dropdown": `dropdown--Tb4Mp`,
	"dropdownAlignRight": `dropdownAlignRight--pS78x`,
	"option": `option--YZ4oV`,
	"checkbox": `checkbox--Wf1EN`,
	"checkboxChecked": `checkboxChecked--n1LWS`,
	"checkmark": `checkmark--WvQso`,
	"optionLabel": `optionLabel--vNagh`,
	"optionLabelChecked": `optionLabelChecked--jF0WI`,
	"optionCount": `optionCount--GB6gl`,
	"actions": `actions--VQyJM`,
	"cancelBtn": `cancelBtn--bfdCt`,
	"confirmBtn": `confirmBtn--CZYtd`,
	"confirmBtnDisabled": `confirmBtnDisabled--jHX9T`,
	"infoIcon": `infoIcon--uP4ah`,
	"hideLabelOnMobile": `hideLabelOnMobile--bv70x`
};
export default ___CSS_LOADER_EXPORT___;
